<template>

    <div class="np-group pt-3">
        <div class="np-header1 np-pb-4">{{ $t("UI.admin.organization")}}</div>
    </div>
    <div class="np-grid pt-3 np-flex-1">
        <div class="np-col np-col-4">
            <div class="np-panel p-2 h-100">
                <div class="np-panel-body">
                    <div class="np-group np-mb-2">          
                        <div class="np-avatar np-avatar-company np-m-0">
                            <img src="@/assets/images/icons/logo.svg#icon" />
                        </div>
                        <div class="np-group np-group-column align-items-start np-pl-4">
                            <h2 class="np-header1 np-pb-2">{{ info?.title}}</h2>
                            <h3 class="np-header3 np-pt-2 np-pb-2" v-if="info.description">{{ $t("UI.organization.info") }}</h3>
                            <div class="np-group np-group-column justify-content-start np-pb-3">
                                <span class="vertical-align-center np-pb-1">{{ info.description ? info?.description : '' }}</span>
                            </div>

                            <div class="np-group np-group-column pb-3">
                                <h3 class="np-header3 pb-1">{{ $t("UI.organization.staffCount") }}</h3>
                                <span>{{ employees.length + "" }}</span>
                            </div>
                            <div class="np-group np-group-column pb-3">
                                <h3 class="np-header3 pb-1">{{ $t("UI.organization.departmentCount") }}</h3>
                                <span>{{ organizationStore.departmentsCount }}</span>
                            </div>                              
                        </div>    
                    </div>

                    <div class="np-group np-group-column mt-4 pb-4">
                        <h3 class="np-header3 pb-1">{{ $t("UI.usedSpace") }}</h3>
                        <span class="np-pb-1">75% {{ $t("UI.from") }} 2 GB</span>
                        <div class="np-progressbar">
                            <div class="np-progressbar-track" :style="{'width': '55%', 'max-width': '100%'}"></div>
                        </div>                                                        
                    </div>                            
                    <div class="np-group np-group-column pb-3">
                        <h3 class="np-header3 pb-1">{{ $t("UI.organization.licenseIssued") }}</h3>
                        <span>14.02.2025</span>
                    </div>  
                    <div class="np-group np-group-column pb-3">
                        <h3 class="np-header3 pb-1">{{ $t("UI.organization.licenseType") }}</h3>
                        <span>Корпоративная</span>
                    </div>  
                    <div class="np-group np-group-column pb-3">
                        <h3 class="np-header3 pb-1">{{ $t("UI.organization.licenseCount") }}</h3>
                        <span>2</span>
                    </div>  
                    <div class="np-group np-group-column pb-3">
                        <h3 class="np-header3 pb-1">{{ $t("UI.organization.licenseUsed") }}</h3>
                        <span>1</span>
                    </div>                                                                                                                                           
                </div>
            </div>
        </div>

        <div class="np-col np-col-8">
            <div class="np-panel p-2 h-100">
                <div class="np-panel-header np-borderless mb-3">
                    <div class="np-group justify-content-between w-100">
                        <h2 class="np-header1 me-3">{{ $t("UI.organization.departmentsInfo") }}</h2>
                        <button class="np-btn np-btn-sm np-light-gray np-p-custom-0" @click="callAddDepartment()">
                            <svg class="icon"><use href="@/assets/images/icons/plus.svg#icon"></use></svg> {{ $t("UI.organization.addDepartment") }}
                        </button> 
                    </div>    
                </div>
                <div class="np-panel-body h-100">
                    <div class="np-group np-group-column pb-2 h-100">
                        <div class="row h-100">
                            <div class="col col-lg-4 np-border-right">
                                <template v-for="department in departments" :key="department.id">
                                    <Accordion 
                                        :options="accordionOptions[department.id]"
                                        :onClick="() => callSelectDepartment(department.id)"
                                    >
                                        <template v-slot:header>
                                            <svg class="icon"><use href="@/assets/images/icons/team.svg#icon"></use></svg>
                                            <span class="d-flex flex-grow-1">{{ department.title }}</span>
                                        </template>
                                        <ul class="list">
                                            <li class="np-borderless ps-2" v-for="subDepartment in department.child" :key="subDepartment.id">
                                                <button 
                                                    class="np-btn np-outline np-borderless d-flex flex-grow-1 justify-content-start np-font-s" 
                                                    :class="selectedDepartment.id === subDepartment.id ? 'selected' : ''"                                                
                                                    @click.stop="callSelectDepartment(subDepartment.id)"
                                                >
                                                    <svg class="icon"><use href="@/assets/images/icons/folder.svg#icon"></use></svg>
                                                    {{ subDepartment.title }}
                                                </button>
                                            </li>   
                                        </ul>
                                    </Accordion> 
                                </template>
                            </div>
                            <div class="col col-lg-8">
                                <!-- Nothing -->
                                <div class="np-group np-group-column h-100 ps-4" v-if="departmentViewMode == 'none'">
                                    <div class="np-group justify-content-between mb-4">
                                        <h3 class="np-header3 pt-2 pb-2">{{ $t("UI.organization.department") }}</h3>                                      
                                    </div>
                                    <div class="np-panel h-100">
                                        <div class="np-panel-body h-100 justify-content-center align-items-center p-4">
                                            {{ $t("UI.organization.selectOrCreate") }}
                                        </div>
                                    </div>
                                </div>                                 
                                <!-- View -->
                                <div class="np-group np-group-column ps-4" v-if="departmentViewMode == 'view'">
                                    <div class="np-group justify-content-between mb-4">
                                        <h3 class="np-header3 pt-2 pb-2">{{ $t("UI.organization.department") }}: {{ selectedDepartment.title }}</h3>
                                        <button class="np-btn np-outline" @click="showDepartmentModal()">
                                            <svg class="icon"><use href="@/assets/images/icons/edit.svg#icon"></use></svg>
                                            {{ $t("UI.edit") }}
                                        </button>                                         
                                    </div>
                                    <div class="np-panel">
                                        <div class="np-panel-body p-4">
                                            <div class="row">
                                                <div class="col me-lg-2 pe-lg-4">
                                                    <div class="mb-4">
                                                        <label class="np-font-m np-f-medium mb-2">{{ $t("UI.organization.department") }}</label>
                                                        <div>{{ selectedDepartment.title }}</div>
                                                    </div>       
                                                    <div class="mb-4">
                                                        <label class="np-font-m np-f-medium mb-2">{{ $t("UI.organization.director") }}</label>
                                                        <div v-if="selectedDepartment.dep_head">{{ selectedDepartment.dep_head?.user_data?.first_name }} 
                                                            {{ selectedDepartment.dep_head?.user_data?.last_name }}
                                                        </div>
                                                        <div v-if="!selectedDepartment.dep_head">
                                                            {{ $t("UI.organization.notAssigned") }}
                                                        </div>                                                        
                                                    </div>  
                                                    <div class="mb-4">
                                                        <label class="np-font-m np-f-medium mb-2">{{ $t("UI.organization.staffCount") }}</label>
                                                        <div>{{ getDepartmentEmployeesCount(selectedDepartment) }}</div>
                                                    </div>                                                                                                                                                                                                                                                               
                                                </div>
                                                <div class="col np-border-left" v-if="selectedDepartment.parent_id > 0">
                                                    <div class="mb-4">
                                                        <label class="np-font-m np-f-medium mb-2">{{ $t("UI.organization.higherDepartment") }}</label>
                                                        <div>{{ parentDepartment.title }}</div>
                                                    </div>       
                                                    <div class="mb-4">
                                                        <label class="np-font-m np-f-medium mb-2">{{ $t("UI.organization.director") }}</label>
                                                        <div v-if="parentDepartment.dep_head">{{ parentDepartment.dep_head?.user_data?.first_name }} 
                                                            {{ parentDepartment.dep_head?.user_data?.last_name }}
                                                        </div>
                                                        <div v-if="!parentDepartment.dep_head">
                                                            {{ $t("UI.organization.notAssigned") }}
                                                        </div> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                           
                            </div>
                        </div>
                    </div>                                                                                                                                          
                </div>
            </div>               
        </div> 
    </div>
    <DepartmentModal 
        modalID="modalDepNewID" 
        @save="saveDepartment" ref="departmentModal" 
    />

</template>

<script>
import { useOrganizationStore } from '@/stores/organizationStore'
import Accordion from '@/components/elements/Accordion.vue'
import Config from '../../config'
import DepartmentModal from '../modals/DepartmentModal.vue'

export default {
    components: {
        Accordion,
        DepartmentModal
    },
    data() {
        return {
            Config,
            selectedDepartment: {
                id: null,
                organization_id: null,
                title: '',
                parent_id: null,
                parent_is_employee: false,
                dep_head: null,
                status_id: 1
            },
            departmentViewMode: "none", // "edit"
        }
    },
    async beforeMount() {
        // none
    },
    computed: {   
        organizationStore() {
            return useOrganizationStore()
        },
        info() {
            return this.organizationStore.organizationInfo
        },
        parentDepartment() {
            if (this.selectedDepartment && this.selectedDepartment.parent_id) {
                return this.organizationStore.department(this.selectedDepartment.parent_id)
            }
            return null
        },  
        departments() {
            return this.organizationStore.departments
        },
        employees() {
            return this.organizationStore.employees
        },
        accordionOptions() {
            const result = {}
            this.departments.forEach(dep => {
                result[dep.id] = {
                    state: 'collapsed',
                    size: 'small',
                    selected: this.selectedDepartment.id === dep.id,
                    hideArrow: dep.child.length === 0,                    
                    onlyArrow: true,
                    additionalClasses: 'simple'
                }
            })
            return result
        },                   
    },
    methods: { 
        getDepartmentEmployeesCount(dep) {
            let count = dep.employee ? dep.employee.length : 0
            dep.child?.forEach(subDep => {
                if (subDep.employee.length > 0) {
                    count += subDep.employee.length
                }
            })  
            return count
        },
        showDepartmentModal() {
            this.$refs.departmentModal.shows(this.selectedDepartment)
        },
        clearSelectedDepartment() {
            this.departmentViewMode = "none"
            this.selectedDepartment = {
                id: null,
                organization_id: null,
                title: '',
                parent_id: null,
                dep_head: null,
                parent_is_employee: false,
                status_id: 1
            }
        },
        callSelectDepartment(id) {
            this.departmentViewMode = "view"
            
            const findDepartment = (departments, targetId, parent = null) => {
                for (const dep of departments) {
                    if (dep.id === targetId) {
                        return { 
                            department: dep,
                            parentId: parent ? parent.id : null 
                        }
                    }
                    if (dep.child && dep.child.length > 0) {
                        const found = findDepartment(dep.child, targetId, dep)
                        if (found) return found
                    }
                }
                return null
            }
            
            const result = findDepartment(this.departments, id)
            
            if (!result) return
            
            const { department: dep, parentId } = result
            
            if (this.selectedDepartment.id === dep.id) {
                this.selectedDepartment = {};
                this.departmentViewMode = "none"
            } else {
                this.selectedDepartment = {
                    ...dep,
                    parent_id: parentId
                }
            }
        },
        callAddDepartment() {
            this.clearSelectedDepartment()
            this.$refs.departmentModal.shows(this.selectedDepartment)
        },
        saveDepartment(dep) {
            if (dep && dep.id) {
                this.selectedDepartment = { ... dep }
            } else {
                this.clearSelectedDepartment()
            }
        }
    }

}
</script>

<style>
</style>